import React from 'react';

import { scriptjsWrapper as getScriptJs } from 'ha/helpers/scriptjsWrapper';

const TABLEAU_API_230 =
  'https://public.tableau.com/javascripts/api/tableau-2.3.0.js';

const OPTIONS = {
  width: '100%',
  height: '727px',
  hideTabs: true,
  hideToolbar: true,
};

interface Props {
  href: string;
}

const Tablau: React.FC<Props> = ({ href }) => {
  const containerRef = React.useRef<HTMLParagraphElement>(null);

  React.useEffect(() => {
    const containerEl = containerRef.current;

    getScriptJs(TABLEAU_API_230).then(() => {
      if (!containerEl || !global.tableau) {
        return;
      }

      return new global.tableau.Viz(containerEl, href, OPTIONS);
    });
  }, []);

  return <p data-test-locator="Tablau graph" ref={containerRef} />;
};

export { Tablau };
